<template>
<div class="similar_anime_block">
  <h2>Похожие</h2>
  <!-- Simple Slider -->
    <div class="my-swiper-container" v-if="isMobile">
        <div class="my-swiper-wrapper">
            <div v-for="anime in animeList" :key="anime.id" class="my-swiper-slider">
              <router-link  :to="'/' + anime.id">
                <img :src="'https://shikimori.one' + anime.image.original">
              </router-link>
              <!-- <a :href="originUrl + '/' + anime.id">
                <img :src="'https://shikimori.one' + anime.image.original">
              </a> -->
              <p class="three-dots" :title="anime.russian">{{ anime.russian }}</p>
            </div>
        </div>
        <!-- Add Pagination -->
        <div class="swiper-pagination"></div>
    </div>

    <!-- SwiperJS Slider -->
    <div class="swiper-container" v-if="!isMobile">
        <div class="swiper-wrapper">
            <div v-for="anime in animeList" :key="anime.id" class="swiper-slide">
              <router-link  :to="'/' + anime.id">
                <img :src="'https://shikimori.one' + anime.image.original">
              </router-link>
              <!-- <a :href="originUrl + '/' + anime.id">
                <img :src="'https://shikimori.one' + anime.image.original">
              </a> -->
              <p class="three-dots" :title="anime.russian">{{ anime.russian }}</p>
            </div>
        </div>
        <!-- Add Pagination -->
        <div class="swiper-pagination"></div>
    </div>
</div>   
</template>



<script>
import axios from 'axios';
import Swiper from '@/shared/lib/third-parties/swiper.js'

export default {
  props: {
    anime_id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      originUrl: window.location.origin,
      title: "",
      animeList: [],
      isMobile: false
    };
  },
  mounted() {
    axios
      .get(`https://shikimori.one/api/animes/${this.anime_id}/similar`)
      .then(response => {
        console.log(response.data)
        this.animeList = response.data;
        if(this.isMobileFunc()){
          this.isMobile = true;
          // this.setWidthOfSimilar();
        }else{
          this.isMobile = false;
          setTimeout(function(){
           new Swiper('.swiper-container', {
            slidesPerView: "auto",
            direction: "horizontal",
            touchRatio: 1.0,
            freeMode: true, 
            grabCursor: true
             
          });
         },20);
        }
      })
      .catch(error => {
        console.log(error);
      });

      // new Swiper('.swiper-container', {
      //       slidesPerView: 5
           
      //   });

      
  },
  updated() {
    if(this.isMobileFunc()){
      this.setWidthOfSimilar();
    }
    
  },
  methods: {
    setWidthOfSimilar: function(){
      console.log(1);
      let swiperWrapper = document.querySelector('.my-swiper-wrapper');
      let widthOfSimilarImages = 0;
      for(let i = 0;i < this.animeList.length;i++){
          widthOfSimilarImages += (175 + 30);
      }
      console.log(widthOfSimilarImages);
      swiperWrapper.style.width = widthOfSimilarImages + 'px';
      return widthOfSimilarImages;
    },
    isMobileFunc: function() {
     if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
       return true
     } else {
       return false
     }
   }
  }
  
};
</script>

<style>
.my-swiper-container::-webkit-scrollbar {
  display: block;
  width: 5px;
  height: 9px;            
}
.my-swiper-container::-webkit-scrollbar-track {
  background: transparent;       
}
.my-swiper-container::-webkit-scrollbar-thumb {
  background-color: #0d6efd;    
  border-radius: 20px;       
}

.similar_anime_block{
  position: relative;
  z-index: 10;
}

.my-slider{
  position: relative;
  z-index: 10;
}

.my-swiper-container{
  overflow: auto;
  margin: 0 150px;
}

.my-swiper-wrapper{
  width: 4875px;
}

.my-swiper-slider{
  display: inline-block;
  width: 175px;
  margin-right: 30px;
}

.my-swiper-slider img{
  width: 100%;
  height: 240px;
  
  border-radius: 8px;
 /* opacity: 0.1;*/
}

.my-swiper-slider p{
  text-align: center;
}

.similar_anime_block .three-dots{ 
  margin-top: 15px;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 175px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-align: center;
}

.similar_anime_block::after { 
  content:'';
  position: absolute;
  z-index: -1;
  width: calc(100% - 20px);
  top: 10px;
  right: -1px;
  width: 5px;
  background: #666;
}


/*SWIPER.JS Slider*/


.swiper-container::-webkit-scrollbar {
  height: 0px;
  width: 100px;
}
.swiper-container::-webkit-scrollbar-track {
  background: transparent;       
}
.swiper-container::-webkit-scrollbar-thumb {
  background-color: #0d6efd;    
  border-radius: 20px;       
}

.similar_anime_block{
  position: relative;
  z-index: 10;
  user-select: none;
}

.swiper-container{
  overflow: auto;
  margin: 0 150px;
  margin-bottom: 20px;
  /* opacity: 0.1;  */
}

.swiper-slide{
  width: auto;
  margin-right: 15px;
}

.swiper-slide{
  display: inline-block;
  width: 175px;
  margin-right: 30px;
}

.swiper-slide img{
  width: 100%;
  height: 240px;
  
  border-radius: 8px;
 /* opacity: 0.1;*/
}

@media only screen and (max-width: 992px) {
  .my-swiper-container::-webkit-scrollbar {
    height: 4px;            
  }

  .my-swiper-container{
    overflow: auto;
    margin: 0;
    transform: rotateX(180deg);
  }

  .my-swiper-wrapper{
    border-top: 10px solid black;
    border-color: transparent;
    transform: rotateX(180deg);
  }

}




@media only screen and (max-width: 600px) {
  .my-swiper-container::-webkit-scrollbar {
    height: 4px;            
  }

  .my-swiper-container{
    overflow: auto;
    margin: 0;
    transform: rotateX(180deg);
  }

  .my-swiper-wrapper{
    border-top: 10px solid black;
    border-color: transparent;
    transform: rotateX(180deg);
  }

  .my-swiper-wrapper:nth-of-type(1){
    margin-left: 20px;
  }

}
</style>